const Error404 = () => {

    return(
        <main className="main p-4">
            <span>ERROR 404!</span>
        </main>
    )
}

export default Error404